import { IApiResponse, IProposta } from '@/interfaces'
import { IPropostaCancelamentoRequest } from '@/interfaces/Proposta'
import { Constants } from './constants'
import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'

const http = AttaHttpClientFactory.create(Constants.API.AttaServices.host)

export class PropostaService {
	static async callActing(proposalId: number, value: boolean) {
		const response = await http.post<IApiResponse<string | null>>(`/propostas/${proposalId}/call-acting`, { callActing: value })
		return response.data
	}

	/**
	 * Cancelar a proposta com justificativa
	 * @param propostaCancelamentoRequest
	 * @returns
	 */
	static async cancelarProposta(propostaCancelamentoRequest: IPropostaCancelamentoRequest) {
		const response = await http.post<IApiResponse<IProposta>>(
			`/propostas/${propostaCancelamentoRequest.propostaId}/cancelar`,
			propostaCancelamentoRequest
		)
		return response.data
	}

	static async chosenBank(proposalId: number) {
		const response = await http.post<IApiResponse<boolean>>(`/propostas/${proposalId}/chosen`)
		return response.data
	}
}
